// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3yqhn","cardContent":"Card_cardContent__3AAno"};